import React from 'react';
import { useTranslation } from 'react-i18next';

// Render saved data only: opening the dashboard must never contact DHL.
export default function OrderTrackingSummary({ trackings = [] }) {
  const { t } = useTranslation();
  const records = Array.isArray(trackings) ? trackings.filter((item) => item?.tracking_number) : [];
  if (!records.length) return <span>{t('tracking_pending')}</span>;

  return (
    <div className="order-tracking-summary">
      {records.map((tracking, index) => (
        <div key={tracking.id ?? `${tracking.tracking_number}-${index}`}>
          <span>{tracking.carrier_name}</span>{' '}
          <strong>{tracking.tracking_number}</strong>
          {tracking.url && !tracking.is_simulated && /^https:\/\//i.test(tracking.url) && (
            <a className="tracking-external-button" href={tracking.url} target="_blank" rel="noopener noreferrer">
              {' '}{t('tracking_link')}
            </a>
          )}
          {(tracking.is_simulated || tracking.tracking_number.startsWith('SIM-DHL-')) && (
            <small className="tracking-simulation">{t('tracking_simulated')}</small>
          )}
        </div>
      ))}
    </div>
  );
}
